import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Normalizes an Auxo asset CDN URL or local path to a same-origin sitePath (/_assets/...)
 */
export function getAssetSitePath(url) {
  if (!url) return '';
  if (url.startsWith('/_assets/')) return url;
  const match = url.match(/assets\.auxodev\.dk\/assets\/[^/]+\/(.+)$/);
  if (match) return `/_assets/${match[1]}`;
  return url;
}

/**
 * Returns an on-the-fly Cloudflare resized image URL for Auxo assets
 * e.g. /cdn-cgi/image/width=800,quality=80,format=auto/_assets/filename.webp
 */
export function getOptimizedImageUrl(url, { width = 800, quality = 80, fit = 'cover', height } = {}) {
  if (!url) return '';
  const sitePath = getAssetSitePath(url);
  if (!sitePath.startsWith('/_assets/')) return url;
  const filename = sitePath.replace('/_assets/', '');
  let options = `width=${width},quality=${quality},format=auto`;
  if (height) options += `,height=${height},fit=${fit}`;
  return `/cdn-cgi/image/${options}/_assets/${filename}`;
}
